import axios from 'axios'

const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_URL_API,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const setToken = (token: string) => {
  axiosClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
export const removeToken = () => {
  delete axiosClient.defaults.headers.common['Authorization']
}

export const createAxiosInstance = ({
  baseURL,
  apiKey,
}: {
  baseURL?: string
  apiKey?: string
} = {}) => {
  const instance = axios.create({
    baseURL: baseURL ?? axiosClient.defaults.baseURL,
    headers: {
      ...axiosClient.defaults.headers.common,
      ...(apiKey ? { 'x-api-key': apiKey } : {}),
    },
  })

  // Add a request interceptor
  axios.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      return config
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error)
    },
  )

  // Add a response interceptor
  axios.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response.data
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error)
    },
  )

  return instance
}

// Add a request interceptor
axiosClient.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  },
)

// Add a response interceptor
axiosClient.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    /**
     * @desc: 401: Unauthorized
     * @todo: Especially for webapp, JWT token should be stored in httpOnly cookie instead of localStorage
     * so discuss with backend to make sure that the token is not accessible from client side
     */
    if (error.response?.status === 401) {
      removeToken()
      localStorage.clear()

      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  },
)

export default axiosClient
